import React from "react";
import { dividerConverter } from "../divider-converter.js";
import { DividerViewer } from "../viewer/divider-viewer.js";
const Divider = ({ node }) => {
  const ricosNode = React.useMemo(() => dividerConverter.fromPm.convert(node.toJSON()), [node]);
  return /* @__PURE__ */ React.createElement(DividerViewer, { node: ricosNode });
};
export {
  Divider
};
//# sourceMappingURL=component.js.map
